module.exports = __webpack_public_path__ + "img/katarina_bedrooms_10.8bdbb56f.jpg";